import useSWR from "swr";
import { customFetcher, getTsDate, notify } from "../../../utils";
import { OBlobFile } from "../Shifts/types";
import apiClient from "../../../apiClient";
import useUser from "../../../customHooks/useUser";

export default function useFiles(guid: string) {

    const { user } = useUser();
    const { s_email, s_unit } = user;
    const key = guid ? `/issue-report/files/${guid}` : null;
    const {
        data,
        mutate
    } = useSWR(key, customFetcher<OBlobFile>, {
        fallbackData: []
    });

    const uploadFile = async (file) => {
        const res = await apiClient.post(`/issue-report/files`, {
            file,
            s_transaction_id: guid,
            s_unit,
            s_created_by: s_email,
            t_created: getTsDate()
        });
        notify('Uploaded');
        mutate();
    }

    const deleteFile = async (file: OBlobFile) => {
        if (file.s_created_by.toUpperCase() !== user.s_email) {
            notify('You can only delete your own files', 'error');
            return;
        } 
        const { id, s_file_name, s_container, s_unit: unit } = file;
        const res = await apiClient.post(`/deleteFile`, {
            id,
            s_file_name,
            s_container,
            unit
        });
        notify('File deleted');
        mutate();
    }

    return {
        files: data,
        uploadFile,
        deleteFile
    };
}